import type { Competency, ApiResponse } from './types';
import { apiGet, apiPost, apiPut } from '../services/api';

export async function getCompetency(id: string): Promise<Competency> {
  try {
    const res = await apiGet<ApiResponse<Competency>>(`/competencies/${id}`);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch competency');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function listCompetencies(): Promise<Competency[]> {
  try {
    const res = await apiGet<ApiResponse<Competency[]>>('/competencies');
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch competencies');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function createCompetency(data: Partial<Competency>): Promise<Competency> {
  try {
    const res = await apiPost<ApiResponse<Competency>>('/competencies', data);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to create competency');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function updateCompetency(id: string, data: Partial<Competency>): Promise<Competency> {
  try {
    const res = await apiPut<ApiResponse<Competency>>(`/competencies/${id}`, data);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to update competency');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}